import React, { Component } from 'react';
import { Svg, Group, Area } from '@potion/element';
import { Stack } from '@potion/layout';
import { interpolateRgb } from 'd3-interpolate';
import { curveCatmullRom } from 'd3-shape';
import { COLORS } from '../constants';

const KEYS = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'];
const COUNT = 5;
const KEY_COUNT = KEYS.length;
const COUNT_RATIO = 1 / (COUNT - 1);

const randomData = (currentData) => {
  const result = [];
  if (currentData) {
    for (let i = 0; i < COUNT; i++) {
      result.push(KEYS.reduce((acc, key) => ({
        ...acc,
        [key]: Math.max(Math.min(
          currentData[i][key] + Math.random() * 0.5 * (Math.random() < 0.5 ? -1 : 1)
          , 1), 0),
      }), {}));
    }
  } else {
    for (let i = 0; i < COUNT; i++) {
      result.push(KEYS.reduce((acc, key) => ({
        ...acc,
        [key]: Math.random(),
      }), {}));
    }
  }
  return result;
};

export default class Stream extends Component {
  constructor(props) {
    super(props);
    this.color = interpolateRgb(props.color || COLORS.PINK, 'white');
    this.state = {
      data: randomData(),
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.generateRandomData();
    }, 2500);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  generateRandomData() {
    this.setState({
      data: randomData(this.state.data),
    });
  }

  render() {
    const { transform, exiting, ...restProps } = this.props;
    return (
      <Svg {...restProps}>
        <Group transform={transform}>
          <Stack
            data={exiting ? [] : this.state.data}
            keys={KEYS}
            animate
            springStiffness={150}
            springDamping={5}
            nodeEnter={d => Object.keys(d).reduce((acc, k) => ({ ...acc, [k]: 0 }), {})}
            nodeExit={d => Object.keys(d).reduce((acc, k) => ({ ...acc, [k]: 0 }), {})}
          >{nodes => nodes.map((node, index) =>
              (<Area
                key={node.key}
                x={(d, i) => i * COUNT_RATIO * restProps.width}
                y1={d => (d.y1 * restProps.height * 0.15)}
                y0={d => (d.y0 * restProps.height * 0.15)}
                points={node.map(([y0, y1]) => ({ y0, y1 }))}
                fill={this.color(index / KEY_COUNT)}
                curve={curveCatmullRom.alpha(0.5)}
              />))}
          </Stack>
        </Group>
      </Svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Stream.js